import React from 'react';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const steps = ['Explore the Blueprints.', 'Review the visual maps.', 'Use the checklists.', 'Test the tools.', 'Apply the framework to your case-planning process.'];
export function Guarantee() {
  return <section className="w-full bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-160" data-mp="1x5d1ky0xt5qx">
      <div className="mx-auto max-w-3xl rounded-3xl border-2 border-gogreen-500/30 bg-[#F1FAF3] p-6 sm:p-10" data-id="element-161" data-mp="19e7ourqamtku">
        <div className="flex flex-col items-center text-center" data-id="element-162" data-mp="14gfmf3s0vp2e">
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-gogreen-500" data-id="element-163" data-mp="1j4k72damyant">
            <ShieldCheckIcon className="h-9 w-9 text-white" aria-hidden="true" data-id="element-164" data-mp="1edu1p027m7t4" />
          </span>
          <h2 className="mt-4 font-display text-[24px] font-bold leading-tight text-ink sm:text-3xl" data-id="element-165" data-mp="qo9icg2598jb">
            7-Day money-back guarantee
          </h2>
          <p className="mt-3 max-w-xl text-[15px] leading-relaxed text-brand-900/75" data-id="element-166" data-mp="loddyfpjbf38">
            Try The Natural Veneer Blueprint™ completely risk-free.
          </p>
        </div>

        <ul className="mx-auto mt-7 max-w-md space-y-2.5" data-id="element-167" data-mp="txku73tfb803">
          {steps.map(step => <li key={step} className="flex items-start gap-2.5 text-[14.5px] text-ink/85" data-id="element-168" data-mp="yp2wbv76nemn">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gogreen-600" aria-hidden="true" data-id="element-169" data-mp="12rg38mxo1il0" />
              <span data-id="element-170" data-mp="6175360duex9">{step}</span>
            </li>)}
        </ul>

        <div className="mx-auto mt-7 max-w-xl space-y-3 text-center text-[14.5px] leading-relaxed text-brand-900/75" data-id="element-171" data-mp="azqqn5b2dop3">
          <p data-id="element-172" data-mp="f0u2zhtwl2lk">
            If within the next 7 days you decide that the system doesn’t provide value to your
            professional practice, you’ll receive a{' '}
            <strong className="font-bold text-ink" data-id="element-173" data-mp="jy2cyv4we0bq">100% refund</strong>.
          </p>
          <p className="text-[13.5px] text-brand-900/65" data-id="element-174" data-mp="1qg8x8duq9gcz">
            No complicated explanations. No endless forms. Simply request your refund within the
            guarantee period.
          </p>
        </div>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-175" data-mp="3rkkxzwzmp3vs">
          <CTAButton label="Try it risk-free for 7 days" note="$27 USD · Instant access" data-id="element-176" data-mp="3ng3gk4gqr2o6" />
        </div>
      </div>
    </section>;
}